module.exports = __webpack_public_path__ + "img/icon191.2587059e.png";